import { StatusPill } from "../components/StatusPill";
import { SectionHeader } from "../components/SectionHeader";
import { MetricCard } from "../components/MetricCard";
import { fetchDashboardSupport } from "../lib/dashboard";
import { DashboardStateView, useDashboardQuery } from "../hooks/useDashboardQuery";

const lanes = ["P0", "P1", "P2", "P3"] as const;

export function SupportOpsPage() {
  const state = useDashboardQuery(fetchDashboardSupport);

  return (
    <>
      <div className="page-header">
        <div>
          <h1>Support operations</h1>
          <p>
            Operational posture for this tenant. Incident lanes stay empty until an authorized
            incident store exists — no demo tickets.
          </p>
        </div>
        <StatusPill label="Read-only" tone="neutral" />
      </div>
      <DashboardStateView
        state={state}
        emptyTitle="Support posture unavailable"
        emptyDetail="Unable to load tenant support posture."
      >
        {(data) => (
          <>
            <div className="metrics-grid">
              <MetricCard
                label="Open risk violations"
                value={String(data.posture.openRiskViolations)}
              />
              <MetricCard
                label="Active relationships"
                value={String(data.posture.activeRelationships)}
              />
              <MetricCard
                label="Broker connections"
                value={String(data.posture.brokerConnections)}
              />
              <MetricCard
                label="Firing alerts"
                value={String(data.monitoring?.firingAlertCount ?? 0)}
              />
            </div>
            <div className="panel" style={{ marginTop: 16 }}>
              <SectionHeader
                title="Monitoring posture"
                subtitle="Read-only process-local SLO/alert summary. No acknowledge, restart, or rollback controls."
              />
              <div className="panel-body kv-grid">
                <div className="kv-item">
                  <div className="k">SLO</div>
                  <div className="v">
                    {data.monitoring?.sloStatus ?? "insufficient_data"} ·{" "}
                    {data.monitoring?.sampleCount ?? 0} samples
                  </div>
                </div>
                <div className="kv-item">
                  <div className="k">Live / broker</div>
                  <div className="v">
                    {data.monitoring?.liveExecutionEnabled ? "LIVE" : "live=false"} /{" "}
                    {data.monitoring?.brokerNetworkEnabled ? "broker" : "broker=false"}
                  </div>
                </div>
                <div className="kv-item">
                  <div className="k">TLS evidence</div>
                  <div className="v">{data.monitoring?.tlsNote ?? "external monitor pending"}</div>
                </div>
                <div className="kv-item">
                  <div className="k">Recent audit events</div>
                  <div className="v">{data.posture.recentAuditCount}</div>
                </div>
              </div>
            </div>
            <div className="panel" style={{ marginTop: 16 }}>
              <SectionHeader title="Escalation lanes" subtitle={data.note} />
              <div className="panel-body">
                <div className="incident-board">
                  {lanes.map((lane) => {
                    const count = data.monitoring?.firingBySeverity?.[lane] ?? 0;
                    return (
                      <section className="incident-col" key={lane} aria-label={`${lane} incidents`}>
                        <div className="incident-col-header">{lane}</div>
                        <div className="incident-item">
                          <h4>{count === 0 ? "Clear" : `${count} firing`}</h4>
                          <p>
                            {count === 0
                              ? `No open ${lane} process-local alerts.`
                              : `${count} process-local ${lane} alert(s). External record is the GitHub monitoring issue.`}
                          </p>
                        </div>
                      </section>
                    );
                  })}
                </div>
              </div>
            </div>
          </>
        )}
      </DashboardStateView>
    </>
  );
}
